import type * as BitmovinNpawAnalyticsBundle from '@foundation-player/plugin-npaw-analytics-bitmovin';
import type * as ChromecastNpawAnalyticsBundle from '@foundation-player/plugin-npaw-analytics-chromecast';
import type * as DashJsNpawAnalyticsBundle from '@foundation-player/plugin-npaw-analytics-dashjs';
import type * as NativeNpawAnalyticsBundle from '@foundation-player/plugin-npaw-analytics-native';
import { BuilderConfig, PlayerType, PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createNpawAnalyticsPlugin: PluginFactoryFunction = (builderConfig: BuilderConfig) => {
  let npawAnalyticsPackage:
    | PackageName.PluginNpawAnalyticsBitmovin
    | PackageName.PluginNpawAnalyticsDashjs
    | PackageName.PluginNpawAnalyticsNative
    | PackageName.PluginNpawAnalyticsChromecast;

  switch (builderConfig.playerType) {
    case PlayerType.Bitmovin:
      npawAnalyticsPackage = PackageName.PluginNpawAnalyticsBitmovin;
      break;
    case PlayerType.DashJs:
      npawAnalyticsPackage = PackageName.PluginNpawAnalyticsDashjs;
      break;
    case PlayerType.Native:
      npawAnalyticsPackage = PackageName.PluginNpawAnalyticsNative;
      break;
    case PlayerType.Chromecast:
      npawAnalyticsPackage = PackageName.PluginNpawAnalyticsChromecast;
      break;
    default:
      console.error(`Cannot enable NPAW analytics for player type "${builderConfig.playerType}"`);
      return undefined;
  }

  return [
    [npawAnalyticsPackage],
    () => {
      const npawAnalyticsGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[npawAnalyticsPackage];

      let pluginConstructor;

      switch (builderConfig.playerType) {
        case PlayerType.Bitmovin:
          pluginConstructor =
            resolveByPackageNameOrThrow<typeof BitmovinNpawAnalyticsBundle>(npawAnalyticsPackage).BitmovinPlugin;
          break;
        case PlayerType.DashJs:
          pluginConstructor =
            resolveByPackageNameOrThrow<typeof DashJsNpawAnalyticsBundle>(npawAnalyticsPackage).DashJsPlugin;
          break;
        case PlayerType.Native:
          pluginConstructor =
            resolveByPackageNameOrThrow<typeof NativeNpawAnalyticsBundle>(npawAnalyticsPackage).NativePlugin;
          break;
        case PlayerType.Chromecast:
          pluginConstructor =
            resolveByPackageNameOrThrow<typeof ChromecastNpawAnalyticsBundle>(npawAnalyticsPackage).ChromecastPlugin;
          break;
      }

      return [new pluginConstructor(builderConfig.pluginConfigs[npawAnalyticsGlobalName])];
    },
  ];
};
